import {
  Divider,
  SafeAreaView,
  VStack,
  ScrollView
} from "@gluestack-ui/themed";
import { CustomHeader } from "@repo/core/components/layout/CustomHeader";
import { StatusBar } from "@repo/core/components/layout/StatusBar";
import { WithdrawReceiptController } from "./controller";
import { TransactionInfoSection } from "@repo/core/components/receipt/sections/TransactionInfoSection";
import { clientInfoMock, storeInfoMock, transactionInfoMock } from "./mocks";
import { StoreInfoSection } from "@repo/core/components/receipt/sections/StoreInfoSection";
import { ClientInfoSection } from "@repo/core/components/receipt/sections/ClientInfoSection";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import { ReceiptFooterSection } from "@repo/core/components/receipt/sections/ReceiptFooterSection";
import { Button } from "@repo/core/components/core/Button";

const WithdrawReceipt = () => {
  const { isMobile, handleGoToSales } = WithdrawReceiptController();
  return (
    <VStack flex={1} bg="$backgroundLight0" height="$100vh" overflow="hidden">
      <StatusBar barStyle="light-content" showCustomStatusBar />
      <SafeAreaView flex={1}>
        <VStack px="$6" py="$2" mb={isMobile ? "$0" : "$4"}>
          <CustomHeader
            title="Comprovante de Transação"
            onBackPress={handleGoToSales}
            rightIcon="times"
            rightIconSize={20}
            rightWebLabel="Fechar"
            onPressRightIcon={handleGoToSales}
          />
        </VStack>
        <VStack flex={1} w="$full" h="$full" alignItems="center">
          <VStack
            justifyContent="flex-start"
            flex={1}
            $md-w="52%"
            $base-w="$full"
          >
            <ScrollView showsVerticalScrollIndicator={false}>
              <VStack alignItems="center" gap={8} p="$4">
                <Icon
                  name="receipt"
                  color="$primary500"
                  size={46}
                  variant="solid"
                />
                <Text fontSize="$2xl" fontWeight={600}>
                  {numberToBrl(1250)}
                </Text>
                <Text>MOBLY</Text>
              </VStack>
              <Divider />
              <VStack px="$6">
                <TransactionInfoSection {...transactionInfoMock} />
              </VStack>
              <Divider />
              <VStack px="$6">
                <StoreInfoSection {...storeInfoMock} />
              </VStack>
              <Divider />
              <VStack px="$6">
                <ClientInfoSection {...clientInfoMock} />
              </VStack>
              <ReceiptFooterSection transactionId="5661214er5f-25df8-982d-h87u-b2y6e3a6c4f88b" />
              <VStack
                flex={1}
                pt={isMobile ? "$4" : "$12"}
                px={isMobile ? "$6" : "$0"}
                pb="$4"
                justifyContent="flex-end"
              >
                <Button
                  text="Compartilhar"
                  action="darker-secondary"
                  variant="outline"
                  leftIcon={{ name: "share", size: 20 }}
                />
              </VStack>
            </ScrollView>
          </VStack>
        </VStack>
      </SafeAreaView>
    </VStack>
  );
};
export default WithdrawReceipt;
